import { useState } from "react";

import { SiteHeader } from "../../components/header/header";
import { FormInput } from "../../components/forms/form-input";
import { useAuthentication } from "../../services/authentication/authentication.context";
import { AppAlert } from "../../components/utils/alert";
import { LoadingIndicator } from "../../components/utils/loader";
import { isNull } from "../../_helpers/isNull";

export const ForgotPassword = () => {

    const { sendResetEmail, isLoading } = useAuthentication();

    const [email, setEmail] = useState('');
    const [onAlert, setOnAlert] = useState();

    const handleInput = (e) => setEmail(e.target.value);

    const handleSubmit = async () => {
        if (isNull(email)) {
            setOnAlert({
                caption: 'Invalid input!',
                message: 'Please provide a value for the email.',
                accept: 'Ok',
                onAccept: () => setOnAlert()
            })
            return;
        };

        const resp = await sendResetEmail(email);
        if (resp?.error) {
            setOnAlert({
                caption: 'Error!',
                message: resp?.error,
                accept: 'Ok',
                onAccept: () => setOnAlert()
            });
            return;
        }

        setOnAlert({
            caption: 'Success',
            message: resp?.message,
            accept: 'Ok',
            onAccept: () => {
                setOnAlert();
                setEmail('');
            }
        })
    }

    return (
        <div className="app-body">
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAcept={onAlert.onAccept}
                    onClose={() => setOnAlert()}
                />
            ) }
            <SiteHeader pageTitle={'Forgot Password'} />
            <div className="slogan-2 login-cap">send password reset email</div>
            <div className="form-container">
                <div className="login-form">
                    <FormInput
                        type={'email'}
                        name={'email'}
                        value={email}
                        onChange={(e) => handleInput(e)}
                        label={"Email e.g. johndoe@example.com"}
                        required={true}
                    />

                    <button
                        className="form-button"
                        onClick={ async() => await handleSubmit()}
                    >
                        Send reset email
                    </button>
                </div>
            </div>
        </div>
    )
}